var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"6","md":"6"}},[_c('v-text-field',{staticStyle:{"visibility":"hidden"},attrs:{"type":"number","disabled":"","outlined":""}})],1),_c('v-col',{attrs:{"cols":"6","md":"6"}},[_c('v-text-field',{staticStyle:{"visibility":"hidden"},attrs:{"type":"number","disabled":"","outlined":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }